<template>
  <div>
    <hr class="border-0 border-b border-neutral-200 my-6 hidden md:block" />
    <div
      ref="banner"
      class="fixed bottom-0 left-0 md:bottom-auto md:left-auto md:static bg-ocean-50 border-t md:border border-ocean-200 py-4 md:py-6 flex flex-col justify-center md:rounded-2xl md:mb-6 lg:mb-0 w-full"
    >
      <div class="flex items-center space-x-2 mx-auto text-ocean-900 text-lg">
        <lottie-player
          autoplay
          loop
          mode="normal"
          :src="lottieUrl"
          class="size-6"
        />
        <span class="font-semibold">{{ $t('search.need-help-choosing-a-vet') }}</span>
      </div>
      <p class="mx-auto mt-2 hidden md:block">
        {{ $t('search.based-on-your-filters-we-will-recommend-a-vet') }}
      </p>
      <vetster-button
        variant="ocean"
        type="button"
        class="mx-auto mt-2 md:mt-4"
        @click="navigateToRecommendVet"
      >
        {{ $t('search.recommend-a-vet') }}
      </vetster-button>
    </div>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterRecommendVetBanner',

  data() {
    return {
      observer: null,
    };
  },

  computed: {
    lottieUrl() {
      return getAssetUrl('lottie/sparkle.json');
    },
  },

  mounted() {
    // Legacy Safari iOS browser.
    if (!window.ResizeObserver) {
      return;
    }

    // TODO: Clean this up, it will clash with https://github.com/vetster/vetster-web/pull/2368
    // https://vetster.atlassian.net/browse/LA-3115
    this.observer = new ResizeObserver((el) => {
      const wrapper = document.querySelector('[data-guided-search-wrapper]');

      wrapper.style.height = !this.$screen('md')
        ? `calc(100% - ${el[0].target.offsetHeight + this.$layout.navHeight}px)`
        : null;
    });

    this.observer.observe(this.$refs.banner);
  },

  beforeUnmount() {
    this.observer?.disconnect();
  },

  methods: {
    navigateToRecommendVet() {
      window.location.href = window.location.href.replace('/gs/', '/gsr/');
    },
  },
};
</script>
